import React from "react";
import IMAGE_URL from "Utilities/IMAGE_URL";
const AboutUsBanner = ({ bannerTitle, bannerDescription, bannerImage }) => {
  return (
    <div className="w-full h-[20vh]  lg:h-[60vh] relative">
      <img
        src={`${IMAGE_URL}/${bannerImage}`}
        alt={bannerTitle}
        className="w-full  h-full object-scover"
      />
      <h1 className="absolute bottom-12 left-10 lg:left-20 transform text-white text-3xl lg:text-4xl font-title font-bold">
        {bannerTitle}
      </h1>
    </div>
  );
};

export default AboutUsBanner;
